import * as Yup from 'yup';

export const schema = Yup.object().shape({
  motivoCancelamento: Yup.string().required('Informe o motivo do cancelamento'),
});
